import React from 'react';

export interface RadioInputProps {
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => any;
  label: string;
  value: string | number;
  name: string;
}

export const RadioInput = ({
  checked,
  onChange,
  label,
  value,
  name,
}: RadioInputProps) => {
  return (
    <label className="relative flex cursor-pointer select-none items-center gap-2 text-sm font-medium text-black dark:text-white">
      <input
        className="sr-only"
        type="radio"
        name={name}
        value={value}
        onChange={onChange}
      />
      <span
        className={`flex h-5 w-5 items-center justify-center rounded-full border ${
          checked ? 'border-primary' : 'border-body'
        }`}
      >
        <span
          className={`h-2.5 w-2.5 rounded-full bg-primary ${
            checked ? 'flex' : 'hidden'
          }`}
        ></span>
      </span>
      {label}
    </label>
  );
};
